<template>
    <modal
        name="cargarPrecios"
        transition="pop-out"
        width="800"
        height="auto"
        :adaptive="true"
        :scrollable="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10 mb-3">
                        <div>
                            <h2>Seleccione la temporada</h2>
                        </div>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close(false)">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="col-12">
                        <multiselect
                            v-model="listaSeleccionada"
                            placeholder="Seleccione la temporada anterior"
                            label="nombre"
                            track-by="id"
                            :max-width="getMultiselectMaxWidth()"
                            :max-height="110"
                            :options="listas"
                            @select="getPrecios($event)"
                            @close="resetPrecios()"
                        />
                    </div>
                    <div v-if="mensaje" class="col-11 alert alert-danger m-auto" style="margin-top: 12px !important;">
                        {{ mensaje }}
                    </div>
                    <div class="col-12 mt-4" v-else-if="precios && precios.length > 0">
                        <h4 class="underline text-center mb-2">Listado de precios</h4>
                        <b-table striped hover :items="precios" :fields="fields">
                            <template #cell(renovacion)="{ item }">
                                <CheckOrCross :condition="item.renovacion" />
                            </template>
                            <template #cell(precio)="{ item }">
                                {{ item.precio | formatear_precio }}
                            </template>
                            <template #cell(seleccionar)="{ item }">
                                <b-checkbox @change="seleccionarPrecio(item)"/>
                            </template>
                        </b-table>
                        <div class="text-right">
                            <Button class="mr-2" v-if="preciosSeleccionados.length > 0" @click="cargarPrecios(preciosSeleccionados)">Cargar seleccionados</Button>
                            <Button :disabled="preciosSeleccionados.length > 0" @click="cargarPrecios(precios)">Cargar todos</Button>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="(!listaSeleccionada ? 'mt-5' : '') + ' card-footer text-right'">
                <Button type="button" name="button" @click.prevent="close()">CERRAR</Button>
            </div>
        </div>
    </modal>
</template>

<script>

    import CheckOrCross from "@/components/backend/components/CheckOrCross";

    export default {
        props: ['listas'],
        data() {
            return {
                listaSeleccionada: null,
                precios: null,
                mensaje: null,
                preciosSeleccionados: [],
                fields: [
                    { key: 'descripcion', label: 'Descripción', class: 'text-center' },
                    { key: 'renovacion', label: 'Renovacion', class: 'text-center' },
                    { key: 'precio', label: 'Precio', class: 'text-center' },
                    { key: 'seleccionar', class: 'text-center' }
                ]
            }
        },
        methods: {
            close() {
                this.$emit('close', 'cargarPrecios', true);
                this.listaSeleccionada = null;
                this.resetPrecios();
                this.preciosSeleccionados = [];
            },        
            getMultiselectMaxWidth() {
                return window.innerWidth <= 600 ? '100%' : '150px';
            },
            seleccionarPrecio(precio) {
                const index = this.preciosSeleccionados.indexOf(precio);

                if (index !== -1) {
                    this.preciosSeleccionados.splice(index, 1);
                } else {
                    this.preciosSeleccionados.push(precio);
                }
            },
            getPrecios(lista) {
                this.mensaje = null;

                const params = {
                    filters : {
                        all: 1
                    },
                    lista_id: lista.id,
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.index'), params).then(res => {
                    if (res.data.length > 0) {
                        this.precios = res.data;
                    } else {
                        this.mensaje = 'Esta lista de abonados no tiene precios configurados';
                    }
                });
            },
            resetPrecios() {
                this.precios = null;
                this.mensaje = null;
            },
            cargarPrecios(precios) {
                const params = {
                    filters : {},
                    lista_id: this.$store.getters.getListaId,
                    precios: precios
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.cargar'), params).then(res => {
                    this.$toast.success(res.data.message);
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.close();
                });
            }
        },
        components : {
            CheckOrCross
        }
    }
</script>
